import Vue from "vue"
import Vuex from "vuex"

import userDetail from "./modules/userDetail.store"


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        userDetail,
    },
})



